<div nz-row class="my-account-users">
  <div nz-col nzSpan="20" nzOffset="2" [ngClass]="'p-3'">
    <h1 nz-typography>Users</h1>
    <nz-alert nz-Class nzType="success" *ngIf="successCredit" nzMessage="Creditele au fost adaugate cu success"></nz-alert>
    <nz-alert nz-Class nzType="error" *ngIf="failCredit" nzMessage="Eroare la adaugarea creditului"></nz-alert>

    <nz-spin [nzSpinning]="creditsUpdating">
      <nz-pagination class="custom-pagination" [(nzPageIndex)]="pageIndex" [nzTotal]="totalPages" [nzPageSizeOptions]="[10, 20, 30, 40, 100]" (nzPageIndexChange)="pageIndexChanged($event)" nzShowSizeChanger [nzPageSize]="pageSize" (nzPageSizeChange)="pageSizeChanged($event)" style="float: right; margin-bottom: 10px"></nz-pagination>
      <nz-table #usersTable [nzData]="usersToDisplay" [nzLoading]="loading" [nzFrontPagination]="false">
        <thead>
          <tr>
            <th>No</th>
            <th nzCustomFilter nz-tooltip nzTooltipTitle="Cauta dupa numele utilizatorului">
              <input nz-input placeholder="NAME" nzBorderless (keyup)="filterBy()" [(ngModel)]="searchValueName" />
            </th>
            <th nzCustomFilter nz-tooltip nzTooltipTitle="Cauta dupa adresa de email">
              <input nz-input placeholder="EMAIL" nzBorderless (keyup)="filterBy()" [(ngModel)]="searchValueEmail" />
            </th>
            <th nz-tooltip nzTooltipTitle="Filtreaza dupa statusul contului: activ sau neinitializat">
              <nz-select class="table-selector" [(ngModel)]="searchStatus" nzBorderless (ngModelChange)="onChange($event)">
                <nz-option nzValue="" nzLabel="Status"></nz-option>
                <nz-option nzValue="1" nzLabel="Active account"></nz-option>
                <nz-option nzValue="0" nzLabel="Uninitialized account"></nz-option>
              </nz-select>
            </th>
            <th *ngIf="userRole != 'user'" nzWidth="140px" style="text-align: center">Alocare credite la utilizator</th>
            <!-- <th *ngIf="userRole != 'user'" nzWidth="80px" style="text-align: center">Credite</th> -->
            <th *ngIf="userRole != 'user'" nzWidth="140px" nzCustomFilter nz-tooltip nzTooltipTitle="Filtreaza dupa credite. Tasteaza un numar (ex: 2) sau 'n' pentru nelimitat (ex: n, n2)">
              <button *ngIf="!creditsUpdating" nz-button class="small-table-btn" nzType="default" nzSize="small" (click)="updateUsersCredit()" nz-tooltip="Actualizeaza creditele utilizatorilor in tabel">Actualizare credit</button>
              <input style="text-align: center" nz-input placeholder="CREDITE" nzBorderless (keyup)="filterBy()" [(ngModel)]="searchCredite" />
            </th>
            <th *ngIf="userRole != 'user'" nzWidth="140px" style="text-align: center" nz-tooltip nzTooltipTitle="Filtreaza dupa numarul de balante procesate. 0 = fara procesari">
              <input nz-input placeholder="PROCESARI" nzBorderless (keyup)="filterBy()" [(ngModel)]="searchValueBalanceProcessed" />
            </th>
            <th *ngIf="userRole != 'user'" nzWidth="100px" style="text-align: center" nz-tooltip nzTooltipTitle="Filtreaza dupa numarul maxim de calculatoare permise (1-3)">
              <input nz-input placeholder="MAX PC" nzBorderless (keyup)="filterBy()" [(ngModel)]="searchMaxDesktops" style="text-align: center" />
            </th>
            <th nzCustomFilter nzWidth="220px" nz-tooltip nzTooltipTitle="Filtreaza dupa luna si anul crearii contului">
              <nz-date-picker nzBorderless nzMode="month" [(ngModel)]="searchCreationDate" nzPlaceHolder="CREATION DATE" (ngModelChange)="filterBy()"></nz-date-picker>
            </th>
            <!-- <th>Actions</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of usersTable.data; let i = index">
            <td>{{ result.id }}</td>
            <td>{{ result.firstName }} {{ result.lastName }}</td>
            <td>{{ result.email }}</td>
            <td>
              <span *ngIf="result.status == 1" style="color: green">Active account</span>
              <span *ngIf="result.status == 0" style="color: red">Uninitialized account</span>
            </td>
            <td style="text-align: center" *ngIf="userRole != 'user'">
              <!-- Icons (show when no form is open for this user) -->
              <i nz-icon nzType="credit-card" nzTheme="outline"
                *ngIf="!(showSelectUser && selectedUser == result.id) && !(showUnlimitedForm && selectedUnlimitedUser == result.id)"
                (click)="toggleShowSelectUser(result.id)"
                style="cursor: pointer; margin-right: 20px; font-size: 22px;"
                nz-tooltip="Adauga credit" nzTooltipPlacement="bottom"></i>
              <i nz-icon nzType="calendar" nzTheme="outline"
                *ngIf="!(showSelectUser && selectedUser == result.id) && !(showUnlimitedForm && selectedUnlimitedUser == result.id)"
                (click)="toggleUnlimitedForm(result.id)"
                style="cursor: pointer; font-size: 22px;"
                nz-tooltip="Procesare nelimitata" nzTooltipPlacement="bottom"></i>

              <!-- Add Credit Form -->
              <ng-container *ngIf="showSelectUser && selectedUser == result.id">
                <input nz-input placeholder="Credite" [(ngModel)]="creditToAdd" style="width: 80px; margin-right: 5px;" />
                <i nz-icon nzType="check-circle" nzTheme="fill"
                  nz-popconfirm nzPopconfirmTitle="Ești sigur că vrei să salvezi modificarea?"
                  nzOkText="Da" nzCancelText="Nu"
                  (nzOnConfirm)="saveChangedUser(result.id)"
                  style="cursor: pointer; color: green; margin-right: 5px;"
                  nz-tooltip="Salveaza" nzTooltipPlacement="bottom"></i>
                <i nz-icon nzType="close-circle" nzTheme="fill" (click)="toggleShowSelectUser(result.id)" style="cursor: pointer; color: red;" nz-tooltip="Anuleaza" nzTooltipPlacement="bottom"></i>
              </ng-container>

              <!-- Unlimited Processing Form -->
              <ng-container *ngIf="showUnlimitedForm && selectedUnlimitedUser == result.id">
                <nz-date-picker
                  [(ngModel)]="unlimitedEndDate"
                  nzPlaceHolder="Data sfarsit"
                  style="width: 130px; margin-right: 5px; --ant-input-placeholder-color: #333;"
                  class="dark-placeholder"
                ></nz-date-picker>
                <i nz-icon nzType="check-circle" nzTheme="fill"
                  nz-popconfirm nzPopconfirmTitle="Ești sigur că vrei să salvezi modificarea?"
                  nzOkText="Da" nzCancelText="Nu"
                  (nzOnConfirm)="saveUnlimitedProcessing(result.id)"
                  [style.cursor]="savingUnlimited ? 'not-allowed' : 'pointer'"
                  style="color: green; margin-right: 5px;"
                  nz-tooltip="Salveaza" nzTooltipPlacement="bottom"></i>
                <i nz-icon nzType="close-circle" nzTheme="fill"
                  (click)="cancelUnlimitedForm()"
                  style="cursor: pointer; color: red;"
                  nz-tooltip="Anuleaza" nzTooltipPlacement="bottom"></i>
              </ng-container>
            </td>
            <td style="text-align: center" *ngIf="userRole != 'user'">
              <button nz-button nzType="primary" nzShape="circle" (click)="showModal(result)">
                <ng-container *ngIf="result.unlimitedSubscription">∞{{ result.credit }}</ng-container>
                <ng-container *ngIf="!result.unlimitedSubscription">{{ result.credit }}</ng-container>
              </button>
            </td>
            <td style="text-align: center" *ngIf="userRole != 'user'">
              {{ result.balanceProcessed }}
            </td>
            <td style="text-align: center; white-space: nowrap;" *ngIf="userRole != 'user'">
              <div style="display: inline-flex; align-items: center; gap: 4px;">
                <nz-input-number
                  [ngModel]="result.maxDesktops"
                  (ngModelChange)="onMaxDesktopsChange(result, $event)"
                  [nzMin]="1"
                  [nzMax]="3"
                  [nzStep]="1"
                  nzSize="small"
                  style="width: 55px;">
                </nz-input-number>
                <ng-container *ngIf="pendingMaxDesktops[result.id] !== undefined">
                  <i nz-icon nzType="check-circle" nzTheme="fill"
                    (click)="confirmMaxDesktops(result)"
                    style="cursor: pointer; color: green; font-size: 18px;"
                    nz-tooltip="Salveaza" nzTooltipPlacement="bottom"></i>
                  <i nz-icon nzType="close-circle" nzTheme="fill"
                    (click)="cancelMaxDesktops(result)"
                    style="cursor: pointer; color: red; font-size: 18px;"
                    nz-tooltip="Anuleaza" nzTooltipPlacement="bottom"></i>
                </ng-container>
              </div>
            </td>
            <td>
              {{ result.dateCreated | momentDate }}
            </td>
            <!--                         {{ result.dateCreated | date:'short':'+0300':'ro' }} -->
            <!-- <td><button nz-button nzType="primary" [nzLoading]="payLoading" (click)="getCredit()">Pay</button></td> -->
          </tr>
        </tbody>
      </nz-table>
    </nz-spin>
  </div>
</div>
<div nz-row class="my-account-pagination">
  <div nz-col nzSpan="19" nzOffset="3" [ngClass]="'p-3'" style="text-align: right">
    <div class="pagination">
      <nz-pagination class="custom-pagination" [(nzPageIndex)]="pageIndex" [nzTotal]="totalPages" [nzPageSizeOptions]="[10, 20, 30, 40, 100]" (nzPageIndexChange)="pageIndexChanged($event)" nzShowSizeChanger [nzPageSize]="pageSize" (nzPageSizeChange)="pageSizeChanged($event)"></nz-pagination>
    </div>
  </div>
</div>
<!-- <nz-modal [(nzVisible)]="isVisibleModal" nzTitle="MobilPay" nzWidth="1024px" (nzOnCancel)="handleCancel()">
    <div *nzModalContent>
        <p><b>URL:</b><br/>{{ mobilpayData.url }}</p>
        <p><b>ENV_KEY:</b><br/>{{ mobilpayData.env_key }}</p>
        <p><b>DATA:</b><br/>{{ mobilpayData.data }}</p>
    </div>
    <div *nzModalFooter>
      <button nz-button nzType="default" (click)="handleCancel()">Închide</button>
    </div>
</nz-modal> -->
<nz-modal [(nzVisible)]="isVisible" nzTitle="Credit {{ userSelectedName }}" (nzOnCancel)="handleCancel()" [nzFooter]="null" nzWidth="90vw">
  <ng-container *nzModalContent>
    <nz-table #filesTable [nzData]="filesData" [nzLoading]="loadingModal" [nzShowPagination]="true">
      <thead>
        <tr>
          <th>Balanţa</th>
          <th>Mesaj</th>
          <th>Amount</th>
          <th>Data încărcării</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of filesTable.data">
          <td>{{ file.file }}</td>
          <td>
            <ng-container *ngIf="file.orderId == null">{{ file.errorMessage }}</ng-container>
            <ng-container *ngIf="file.orderId != null">Tranzactie Mobilpay {{ file.orderId }}</ng-container>
          </td>
          <td>{{ file.balanceAmount }}</td>
          <td>{{ file.dateCreated }}</td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>
</nz-modal>
